<template>
    <div>
        <div class="modal fade modern-modal" tabindex="-1" id="ModalProcessoPermissao" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal" aria-label="Fechar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2L4 5V11C4 16.52 7.8 21.74 12 23C16.2 21.74 20 16.52 20 11V5L12 2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M10 14L8 12L10 10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14 10L16 12L14 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 15H12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M11.5 9H12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Permissões do Processo</h2>
                            <p>Defina quem pode visualizar, realizar perguntas e enviar artefatos.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="section-header">
                            <div class="section-info" v-if="nomeProcesso">
                                <span class="info-chip">Processo: <strong>{{ nomeProcesso }}</strong></span>
                            </div>
                            <button class="modern-btn modern-btn-primary" @click="novaPermissao">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                </svg>
                                <span>{{ formNovaPermissao ? 'Fechar formulário' : 'Nova permissão' }}</span>
                            </button>
                        </div>

                        <div class="permission-card" v-show="formNovaPermissao">
                            <div class="card-modern">
                                <div class="card-modern-header">
                                    <h4>Adicionar permissão</h4>
                                    <p>Escolha um usuário e selecione as permissões que ele poderá exercer neste processo.</p>
                                </div>
                                <form class="card-modern-body" id="formProcessoPermissao">
                                    <div class="form-grid form-grid-2">
                                        <div class="form-group">
                                            <label class="form-label" for="dsLogin">Tipo</label>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="tpPermissao" id="tpPermissao1" v-model="tpPermissao" value="u">
                                                <label class="form-check-label" for="tpPermissao1">
                                                    Usuário
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="tpPermissao" id="tpPermissao2" v-model="tpPermissao" value="s">
                                                <label class="form-check-label" for="tpPermissao2">
                                                    Setor
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="tpPermissao == 'u'">
                                            <label class="form-label" for="dsLogin">Usuário</label>
                                            <select v-model="dsLogin"
                                                    class="form-control"
                                                    :class="{ 'border-danger': camposInvalidos.dsLogin }"
                                                    id="dsLogin">
                                                <option disabled value="">Selecione:</option>
                                                <template v-for="usuario in lstUsuarios">
                                                    <option :key="usuario.dsLogin" :value="usuario.dsLogin" v-if="usuario.dsLogin != user.usuario.dsLogin">
                                                        {{ usuario.nmUsuario }}
                                                    </option>
                                                </template>
                                            </select>
                                        </div>
                                        <div class="form-group" v-else>
                                            <label class="form-label" for="idSetor">Setor</label>
                                            <select v-model="idSetor"
                                                    class="form-control"
                                                    :class="{ 'border-danger': camposInvalidos.idSetor }"
                                                    id="idSetor">
                                                <option disabled value="0">Selecione:</option>
                                                <option :key="setor.idSetor" :value="setor.idSetor" v-for="setor in lstSetor">
                                                    {{ setor.nmSetor }}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Permissões</label>
                                            <div class="permission-options" :class="{ 'has-error': camposInvalidos.checks }">
                                                <label class="permission-option"
                                                       v-for="(item, index) in lstProcessoTipoPermissao"
                                                       :key="index"
                                                       :class="{ 'active': item.flAtivo }">
                                                    <input class="permission-checkbox"
                                                           type="checkbox"
                                                           :id="'check'+item.idTipoPermissao"
                                                           v-model="item.flAtivo">
                                                    <span>{{ item.nmTipoPermissao }}</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-footer">
                                        <button class="modern-btn modern-btn-success w-100" @click="salvarProcessoPermissao" type="button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.08-.02l3.99-4.99a.75.75 0 0 0-.01-1.05z" />
                                            </svg>
                                            Salvar permissões
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div class="table-section">
                            <div class="table-section-header">
                                <h4 class="section-subtitle">Permissões configuradas</h4>
                                <p class="section-description">Revise os usuários autorizados e ajuste quando necessário.</p>
                            </div>
                            <div class="table-wrapper modern-table">
                                <table class="custom-table" style="min-width: 100%">
                                    <thead v-if="lstProcessoPermissao">
                                        <tr>
                                            <th class="text-center">Usuário</th>
                                            <th class="text-center">Setor</th>
                                            <th class="text-center" v-for="(item, index) in lstProcessoTipoPermissao" :key="index">{{ item.nmTipoPermissao }}</th>
                                            <th class="text-center" style="width: 1%">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(registro, index) in lstProcessoPermissao" :key="index">
                                            <td data-label="Usuário" class="text-center">
                                                <span class="user-badge" v-if="registro.usuario">{{ registro.usuario.nmUsuario }}</span>
                                                <span  v-else>-</span>
                                            </td>
                                            <td data-label="Usuário" class="text-center">
                                                <span class="user-badge" v-if="registro.setor">{{ registro.setor.nmSetor }}</span>
                                                <span v-else>-</span>
                                            </td>
                                            <td class="text-center"
                                                v-for="(item, index) in lstProcessoTipoPermissao"
                                                :key="index"
                                                :data-label="item.nmTipoPermissao">
                                                <span class="status-chip"
                                                      :class="registro.lstProcessoPermissao.find(x => x.idTipoPermissao == item.idTipoPermissao)?.idProcessoPermissao > 0 ? 'status-chip-success' : 'status-chip-danger'">
                                                    <svg v-if="registro.lstProcessoPermissao.find(x => x.idTipoPermissao == item.idTipoPermissao)?.idProcessoPermissao > 0"
                                                         xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.08-.02l3.99-4.99a.75.75 0 0 0-.01-1.05z" />
                                                    </svg>
                                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                                    </svg>
                                                    {{ registro.lstProcessoPermissao.find(x => x.idTipoPermissao == item.idTipoPermissao)?.idProcessoPermissao > 0 ? 'Ativo' : 'Inativo' }}
                                                </span>
                                            </td>
                                            <td data-label="Ações" class="text-center action-cell">
                                                <div class="action-buttons">
                                                    <button @click="editarProcessoPermissao(registro.permissao.idProcessoPermissao)"
                                                            class="action-btn action-btn-view d-none"
                                                            title="Editar Permissão">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                        </svg>
                                                        Editar
                                                    </button>
                                                    <button @click="excluirProcessoPermissao(registro.usuario?.dsLogin,registro.setor?.idSetor)"
                                                            class="action-btn action-btn-delete"
                                                            title="Excluir Permissão">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                        </svg>
                                                        Remover
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr v-if="lstProcessoPermissao.length === 0">
                                            <td :colspan="lstProcessoTipoPermissao.length + 2" class="empty-state">
                                                <div class="empty-content">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                    </svg>
                                                    <h3 class="empty-title">Nenhuma permissão cadastrada</h3>
                                                    <p class="empty-description">Utilize o botão “Nova permissão” para adicionar usuários ao processo.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'

    export default {
        name: 'ModalProcessoPermissao',
        components: {
            
        },
        props: {
            showModal: Boolean,
            idProcesso: String,
            dsNome: String,
        },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
            user() {
                return this.$store.state.user
            },
            nomeProcesso() {
                if (this.dsNome && this.dsNome.trim()) {
                    return this.dsNome;
                }
                return this.processo && this.processo.dsNome ? this.processo.dsNome : '';
            }
        },
        data: function () {
            return {
                lstProcessoTipoPermissao: [],
                lstProcessoPermissao: [],
                lstUsuarios: [],
                lstSetor: [],
                dsLoginProprietario: '',
                formNovaPermissao: false,
                processo: {},
                dsLogin: "",
                idSetor: 0,

                camposInvalidos: {
                    dsLogin: false,
                    idSetor: false,
                    checks: false,
                },

                tpPermissao: 'u',
            }
        },
        methods: {
            load() {
                this.getProcesso();
                this.getProcessoPermissoes();
                this.getUsuariosContrato();
                this.getSetores();
                this.getProcessoTipoPermissao();
            },

            getProcessoPermissoes() {
                let $this = this;
                $this.getProcesso();
                axios.get(`${urlApi}/ProcessoPermissao/GetGridProcesso/${$this.idProcesso}`)
                    .then(res => {
                        $this.lstProcessoPermissao = [];
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstProcessoPermissao = result;
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            getUsuariosContrato() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosContrato/`)
                    .then(res => {
                        $this.lstUsuarios = [];
                        if (res.data.success) {
                            var result = res.data.data;

                            $this.lstUsuarios = result.filter(usuario => usuario.dsLogin !== $this.dsLoginProprietario);

                            if ($this.lstUsuarios.length == 0 && $this.user.usuario.idContrato == 0) {
                                $this.getUsuarioInternoAtual();
                            }
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.data) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            async getUsuarioInternoAtual() {
                let $this = this;
                try {
                    const res = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosInternosAtuais/`);

                    if (res.data?.success && Array.isArray(res.data.data)) {
                        var result = res.data.data;
                        $this.lstUsuarios = result.filter(usuario => usuario.dsLogin !== $this.dsLoginProprietario);

                    } else {
                        avisoErro(res.data?.msg || "Não foi possível carregar os usuários internos.");
                    }
                } catch (err) {
                    avisoErro(err?.response?.data || "Não foi possível carregar o usuário interno.");
                }
            },

            getSetores() {
                let $this = this;
                axios.get(`${urlApi}/Setor/Get`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstSetor = result.rows;

                        } else {
                            avisoErro("Não foi possível carregar os setores.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.status == 403) {
                            avisoErro("Você não tem acesso a esse produto.");
                            setTimeout(() => window.location.href = "/Home", 2000);
                        } else {
                            avisoErro(res.response?.data || res.response?.statusText || "Erro ao carregar");
                        }
                    })
                    .finally(() => {
                        $this.isLoading = false;
                    });
            },

            getProcessoTipoPermissao() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoPermissao/GetProcessoTipoPermissao/`)
                    .then(res => {
                        $this.lstProcessoTipoPermissao = [];
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.lstProcessoTipoPermissao = result;
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro("Não foi possível carregar os dados.");
                        }
                    });
            },

            novaPermissao() {
                this.formNovaPermissao = !this.formNovaPermissao;
                this.tpPermissao = 'u';
                if (!this.formNovaPermissao) {
                    this.camposInvalidos.dsLogin = false;
                    this.camposInvalidos.idSetor = false;
                    this.camposInvalidos.checks = false;
                }
            },

            excluirProcessoPermissao(dsLogin,idSetor) {
                let $this = this;
                Swal.fire({
                    title: 'Excluir Permissão?',
                    text: 'Essa ação removerá a permissão.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/ProcessoPermissao/Delete`, { dsLogin: dsLogin, idSetor: idSetor, idProcesso: $this.idProcesso })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Permissão excluída com sucesso!", "success");
                                    $this.getProcessoPermissoes();
                                } else {
                                    avisoErro(res.data.msg || "Erro ao excluir Permissão.");
                                }
                            })
                            .catch((err) => {
                                const res = err.response;

                                if (res && res.status === 409 && res.data?.errors?.includes("RESP_ARTEFATO")) {
                                    const modelos = res.data?.data?.modelos || [];
                                    const html = modelos.length
                                        ? `<p>Este usuário é responsável pelos seguintes modelos:</p>
                                             <ul style="text-align:left;margin:0 auto;max-width:420px;">
                                               ${modelos.map(m => `<li>${m}</li>`).join('')}
                                             </ul>`
                                        : '';

                                    Swal.fire({
                                        icon: 'info',
                                        title: 'Ação bloqueada',
                                        html: `${html || 'Este usuário é responsável por um artefato deste processo.'}
                                            <p style="margin-top:8px">Remova a responsabilidade antes de revogar a permissão.</p>`,
                                        confirmButtonText: 'Entendi'
                                    });
                                    return;
                                }

                                if (res?.data?.msg) {
                                    avisoErro(res.data.msg);
                                } else {
                                    avisoErro("Erro ao excluir Permissão.");
                                }
                            });

                    }
                });
            },

            getProcesso() {
                let $this = this;

                const id = this.$route.params.id
                axios.get(`${urlApi}/Processo/Get/${id}`)
                    .then(res => {
                        if (res.data.success) {
                            $this.processo = res.data.data.processo;
                            $this.dsLoginProprietario = $this.processo.dsLogin;
                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.')
                        }
                    })
                    .catch(err => {
                        $this.flProcesso = true;
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar processo!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });
            },

            validarCamposObrigatorios() {
                const campos = this.camposInvalidos;
                campos.dsLogin = !this.dsLogin.trim();
                campos.idSetor = this.idSetor;

                if (!this.lstProcessoTipoPermissao.find(x => x.flAtivo == true)) {
                    campos.checks = true;
                } else {
                    campos.checks = false;
                }

                if (this.tpPermissao == 'u') {
                    if (this.dsLogin && this.dsLogin != '') {
                        campos.dsLogin = false;
                    } else {
                        campos.dsLogin = true;
                    }
                    campos.idSetor = false;
                } else {
                    if (this.idSetor && this.idSetor > 0) {
                        campos.idSetor = false;
                    } else {
                        campos.idSetor = true;
                    }
                    campos.dsLogin = false;
                }

                const invalido = Object.values(campos).some(v => v);
                if (invalido) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                }

                return !invalido;
            },

            async salvarProcessoPermissao() {
                if (!this.validarCamposObrigatorios()) return;

                const payload = {
                    idProcessoPermissao: null,
                    idProcesso: parseInt(this.idProcesso),
                    dsLogin: (this.dsLogin == '' ? null : this.dsLogin),
                    idSetor: (this.idSetor == 0 ? null : parseInt(this.idSetor) ),
                    lstPermissoes: this.lstProcessoTipoPermissao.map(x => ({ Item1: x.idTipoPermissao, Item2: (x.flAtivo ? x.flAtivo : false) }))
                };

                try {
                    const res = await axios.post(`${urlApi}/ProcessoPermissao/Post`, payload);

                    if (res.data.success) {
                        avisoToast("Permissão salva com sucesso!");
                        this.load();
                    } else {
                        avisoErro(res.data.msg || "Erro ao salvar a Permissão.");
                    }
                } catch (err) {
                    if (err.response != null) {
                        avisoErro(err.response.data.msg || "Erro ao salvar a Permissão.");
                    } else {
                        avisoErro("Erro na requisição ao salvar a Permissão.");
                    }
                    
                }
            }
        },
        mounted: function () {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalProcessoPermissao');

        },
        watch: {
            showModal: function () {
                
                this.myModalAlternative.show();
                this.load();
            },
            tpPermissao: function () {
                this.dsLogin = '';
                this.idSetor = 0;
            }

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff !important;
    }

        .btn-close-modern:hover {
            transform: scale(1.08);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        }

    .btn-md{
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }
        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

    .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 6px 0 0;
        color: #475569;
        font-size: 14px;
        max-width: 420px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 40px 40px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

    .section-info {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .info-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        color: #2563eb;
        background: rgba(37, 99, 235, 0.12);
        letter-spacing: 0.5px;
    }

    .section-title {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #0f172a;
        letter-spacing: -0.2px;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.25s ease;
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
        min-height: 44px;
        background: #1d4ed8;
        color: #fff;
    }

        .modern-btn svg {
            flex-shrink: 0;
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 12px 24px rgba(37, 99, 235, 0.25);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    .permission-card {
        animation: fadeIn 0.25s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(12px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .card-modern {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        overflow: hidden;
    }

    .card-modern-header {
        padding: 24px 28px 12px;
    }

        .card-modern-header h4 {
            margin: 0;
            font-size: 18px;
            font-weight: 700;
            color: #0f172a;
        }

        .card-modern-header p {
            margin: 6px 0 0;
            color: #64748b;
            font-size: 14px;
        }

    .card-modern-body {
        padding: 0 28px 28px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .form-grid {
        display: grid;
        gap: 20px;
    }

    .form-grid-2 {
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 12px 14px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
    }

        .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
            background: #ffffff;
        }

    .permission-options {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 14px;
        border-radius: 14px;
        border: 2px solid rgba(148, 163, 184, 0.2);
        background: rgba(241, 245, 249, 0.6);
        min-height: 90px;
    }

        .permission-options.has-error {
            border-color: #f87171;
            box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.18);
        }

    .permission-option {
        position: relative;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid rgba(148, 163, 184, 0.35);
        color: #1e293b;
        background: #ffffff;
        transition: all 0.2s ease;
    }

        .permission-option:hover {
            transform: translateY(-1px);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.1);
        }

        .permission-option.active {
            border-color: #2563eb;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 10px 24px rgba(37, 99, 235, 0.35);
        }

    .permission-checkbox {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }

    .form-footer {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .border-danger {
        border-color: #f87171 !important;
        box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.18);
    }

    .table-section {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .table-section-header {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .section-subtitle {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
    }

    .section-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .table-wrapper {
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        overflow: hidden;
        background: #ffffff;
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
    }

    .custom-table {
        width: 100%;
        border-collapse: collapse;
    }

        .custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .custom-table th,
        .custom-table td {
            padding: 16px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.2);
            font-size: 14px;
            color: #1e293b;
        }

        .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 13px;
            letter-spacing: 0.5px;
            color: #1f2937;
        }

    .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.08);
        transition: background 0.2s ease;
    }

    .user-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 8px 14px;
        border-radius: 999px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        color: #2563eb;
        font-weight: 600;
        border: 1px solid #bfdbfe;
    }

    .status-chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 999px;
        font-weight: 600;
        font-size: 12px;
        border: 1px solid transparent;
    }

    .status-chip-success {
        background: rgba(16, 185, 129, 0.12);
        color: #047857;
        border-color: rgba(16, 185, 129, 0.35);
    }

    .status-chip-danger {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

    .action-cell {
        white-space: nowrap;
    }

    .action-buttons {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    .action-btn-delete {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .empty-state {
        text-align: center;
        padding: 60px 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    @media (max-width: 768px) {
        .modal-modern-content {
            padding-top: 48px;
        }

        .modal-modern-header {
            padding: 28px 24px 18px;
            flex-direction: column;
        }

        .modal-modern-body {
            padding: 24px;
        }

        .section-header {
            flex-direction: column;
            align-items: stretch;
        }

        .modern-btn {
            width: 100%;
            justify-content: center;
        }

        .card-modern-header,
        .card-modern-body {
            padding-left: 20px;
            padding-right: 20px;
        }

        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

        .custom-table thead {
            display: none;
        }

        .custom-table tr {
            margin-bottom: 16px;
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
        }

        .custom-table td {
            border: none;
            border-bottom: 1px solid rgba(148, 163, 184, 0.15);
            padding: 14px 16px;
            text-align: left !important;
        }

            .custom-table td:last-child {
                border-bottom: none;
            }

            .custom-table td::before {
                content: attr(data-label);
                display: block;
                font-weight: 700;
                margin-bottom: 6px;
                text-transform: uppercase;
                color: #64748b;
                font-size: 12px;
            }
    }
</style>

